module.exports = __webpack_public_path__ + "static/img/log2.528963d6.png";